/* eslint-disable no-param-reassign */
import { getCookie } from 'utils/functions';
import axios from 'axios';
import { captchaInterceptor } from '@piplapps/pipl-ui';
import { parseParams } from 'utils/searchUtils';
import AppConfig from 'config/AppConfig';

import { CANCEL } from 'redux-saga';

const TIMEOUT = process.env.NODE_ENV === 'development' ? 120000 : 120000;
const isIE =
  navigator.appName === 'Microsoft Internet Explorer' ||
  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv 11/));

const sleep = delay =>
  new Promise((resolve, reject) => {
    setTimeout(resolve, delay);
  });

async function versionCheckerMiddleware(config) {
  try {
    const newVersion = config.headers['client-version'];
    const oldVersion = AppConfig.CLIENT_VERSION;

    if (oldVersion && newVersion - oldVersion > 0) {
      window.location.reload();
      await sleep(1000); // Lets hold the request cause anyway we reloading the page...
    }
  } catch (e) {
    console.log('ERROR ');
  } finally {
    return config; //eslint-disable-line
  }
}

function createClient({ baseURL, timeout = TIMEOUT }) {
  const axiosClient = axios.create({ baseURL, timeout });

  axiosClient.interceptors.response.use(versionCheckerMiddleware);

  axiosClient.interceptors.request.use(config => {
    config.headers['X-REQUESTED-WITH'] = 'XMLHttpRequest';
    config.paramsSerializer = parseParams;

    if (config.method !== 'get') {
      const csrfToken = getCookie(P.csrftoken_cookie_name);
      if (csrfToken) {
        config.headers['X-CSRFTOKEN'] = csrfToken;
      }
    }

    if (config.method !== 'post' && isIE) {
      config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      config.params = {
        ...config.params,
        _: Date.now().toString(),
      };
    }

    return config;
  });

  axiosClient.interceptors.response.use(request => request, captchaInterceptor('manage/captcha'));

  function sendRequest({ method, url, data = {}, params = {}, ...rest }) {
    const source = axios.CancelToken.source();

    const req = axiosClient({
      method,
      data,
      params,
      url,
      cancelToken: source.token,
      ...rest,
    });

    req[CANCEL] = () => source.cancel();

    return req;
  }

  return {
    sendRequest,
  };
}

export default createClient;
